import { HeaderSearchSelection, ModelEntitySearchResponseItem } from '@upright/common/model/search/types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { useState } from 'react';
import { MenuListProps } from 'react-select';
import styled from 'styled-components';
import { getTextStyle } from '../../../../../../../generic/content/texts/bou-text/text-style';
import { getTitleStyle } from '../../../../../../../generic/content/texts/bou-title/title-style';
import { getWindowHeight } from '../../../../../../../generic/layout/utilities/window-height';
import { searchBackgroundColor } from '../../shared';
import { FiltersBlock } from './filters-block';

interface FactoryProps {
  hideFilters?: boolean;
  filter: HeaderSearchSelection | undefined;
  onFilterChange: (value: HeaderSearchSelection) => void;
  hasSuggestions: boolean;
}

export function getMenuList(factoryProps: FactoryProps) {
  return function MenuList(props: MenuListProps<ModelEntitySearchResponseItem, false>) {
    const showFilters = factoryProps.hideFilters !== true;
    const [top, setTop] = useState<number | undefined>();
    const padding = 20;
    const minHeight = 200;
    const maxHeight = top ? Math.max(getWindowHeight() - top - padding, minHeight) : undefined;
    return (
      <MenuRoot
        ref={ref => {
          if (ref) {
            const _top = ref.getBoundingClientRect().top;
            setTop(_top);
          }
        }}
        style={{ maxHeight }}
      >
        {showFilters && <FiltersBlock filter={factoryProps.filter} onFilterChange={factoryProps.onFilterChange} />}
        {factoryProps.hasSuggestions && <ExampleSearches>Example searches</ExampleSearches>}
        <MenuMain>
          <div>{props.children}</div>
        </MenuMain>
      </MenuRoot>
    );
  };
}

const MenuRoot = styled.div`
  ${getTextStyle({ size: 'xxs' })};
  font-weight: 500;
  padding: 1em 2em;
  max-height: 300px;
  border: 1px solid ${BouColor.PLATFORM_BORDER_GRAY_DARK};
  border-radius: 4px;
  background-color: ${searchBackgroundColor};
  overflow-y: auto;
  scrollbar-gutter: stable;
`;

const MenuMain = styled.div`
  margin-top: 1em;
`;

const ExampleSearches = styled.div`
  ${getTitleStyle({ size: 'h6' })};
  margin-top: 1em;
`;
